import taskAddContactModalTemplate from './taskAddContactModal.html';
import taskAddAccountModalTemplate from './taskAddAccountModal.html';
import campaignSearchModalTemplate from './campaignSearchModal.html';

export default class TaskAddController {

    constructor($scope, $state, ApiTasks, ApiCampaigns, ApiUser, ApiTeam, ApiContacts, $ionicLoading, $ionicPopup, $rootScope,
        $stateParams, $cordovaCalendar, $filter, $ionicHistory, ApiInvestors, DATE_FORMAT, $ionicModal, ApiSelections, TaskMutationTrackingService) {
        this.$scope = $scope;
        this.$cordovaCalendar = $cordovaCalendar;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$ionicHistory = $ionicHistory;
        this.DATE_FORMAT = DATE_FORMAT;
        this.addContactModal = $ionicModal.fromTemplate(taskAddContactModalTemplate, { scope: $scope });
        this.addAccountModal = $ionicModal.fromTemplate(taskAddAccountModalTemplate, { scope: $scope });
        this.campaignSearchModal = $ionicModal.fromTemplate(campaignSearchModalTemplate, { scope: $scope });
        this.ApiCampaigns = ApiCampaigns;
        this.ApiContacts = ApiContacts;
        this.ApiTasks = ApiTasks;
        this.ApiTeam = ApiTeam;
        this.ApiUser = ApiUser;
        this.ApiInvestors = ApiInvestors;
        this.ApiSelections = ApiSelections;
        this.TaskMutationTrackingService = TaskMutationTrackingService;

        this.campaignContacts = [];
        this.campaigns = [];
        this.contacts = [];
        this.members = [];
        this.task = {};
        this.investorSubtypes = [];
        this.contactTypes = [{ id: 'PACKAGE', value: 'advinda contacts', selected: true }, { id: 'TEAM', value: 'custom contacts', selected: false }];
        this.accountTypes = [{ id: 'PACKAGE', value: 'advinda accounts', selected: true }, { id: 'TEAM', value: 'custom accounts', selected: false }];

        this.editMode = false; // flag true if new entry
        this.currentTaskCopy = {};
        this.spinnerCounter = 0;
        this.commentInFocus = false;
        this.summaryInFocus = false;

        this.taskSubjects = {
            'TEASER': 'SUBJECT_TEASER_REMINDER',
            'CALL': 'SUBJECT_FOLLOW_UP_CALL',
            'MEETING': 'SUBJECT_MEETING',
            'EMAIL': 'SUBJECT_EMAIL',
            'GENERAL': 'SUBJECT_GENERAL'
        };

        this.taskRelatedToTypes = {
            'CAMPAIGN': 'TASK_RELATED_TO_CAMPAIGN',
            'CONTACT': 'TASK_RELATED_TO_CONTACT',
            'INVESTOR': 'TASK_RELATED_TO_INVESTOR_ACCOUNT'
        };

        this.taskStati = {
            'OPEN': 'STATUS_OPEN',
            'DONE': 'STATUS_DONE',
            'OVERDUE': 'STATUS_OVERDUE'
        };
        this.tasksCount = this.$stateParams.tasksCount;

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.closeModal() != null) self.closeModal();
            if (self.closeCampaignSearchModal() != null) self.closeCampaignSearchModal();
        });
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
            duration: 10000
        });
        this.task.task = {};
        this.ApiTeam.getTeamMembers({ active: true }).then((res) => {
            if (res != undefined) {
                this.members = res;
            } else {
                this.ApiUser.getUser().then((res) => {
                    if (typeof res != 'undefined') {
                        this.task.assignee = res;
                        this.members.push(res);
                    }
                });
                this.$ionicLoading.hide();
            }
        });

        this.resolveRedirection();

        /** Checking if edit mode */
        if (this.$stateParams.taskId && !this.task.emailInfo) {
            const id = this.$stateParams.taskId;
            this.editMode = true; // enable the edit flag

            this.ApiTasks.getTask(id).then((res) => {
                if (typeof res != 'undefined') {
                    this.task = res;
                    this.currentTaskCopy = JSON.parse(JSON.stringify(res));
                    this.task.task.startDate = new Date(this.task.task.startDate); // avoid date issue
                    this.task.task.dueDate = new Date(this.task.task.dueDate); // avoid date issue

                    if (this.task.campaign !== null) {
                        this.loadCampaigns();
                        this.ApiCampaigns.getCampaignContacts(this.task.campaign.campaignId).then((res) => {
                            if (typeof res != 'undefined') {
                                this.campaignContacts = res;
                            }
                            this.$ionicLoading.hide();
                        });
                    }
                }

                this.$ionicLoading.hide();
            });

        } else if (this.$stateParams.taskId && this.task.emailInfo) {
            const id = this.$stateParams.taskId;
            this.editMode = true; // enable the edit flag

            this.ApiTasks.getTask(id).then((res) => {
                if (typeof res != 'undefined') {
                    this.task = res;
                    this.task.task.startDate = new Date(this.task.task.startDate); // avoid date issue
                    this.task.task.dueDate = new Date(this.task.task.dueDate); // avoid date issue
                }

                this.$ionicLoading.hide();
            });
        } else {
            this.task.task.startDate = new Date();
            this.task.task.dueDate = this.DATE_FORMAT;
            this.$ionicLoading.hide();
        }
    }

    showSpinner() {
        this.spinnerCounter++;
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
    }

    hideSpinner() {
        this.spinnerCounter--;
        if (this.spinnerCounter <= 0)
            this.$ionicLoading.hide();
    }

    saveTask() {
        this.task.task.startDate = this.removeTimeFromDateAndAddHour(this.task.task.startDate, 9);
        this.task.task.dueDate = this.removeTimeFromDateAndAddHour(this.task.task.dueDate,10);
        if (!this.validate()) return;
        if (this.editMode)
            this.editTask();
        else
            this.insertTask();
    }

    insertTask() {
        this.showSpinner();
        this.ApiTasks.postTask(this.task).then((res) => {
            this.hideSpinner();
            if (!res) return;
            // if (ionic.Platform.isWebView())
            // this.createCalenderEventInMobile(res); expected in release 2.0
            this.$ionicHistory.goBack();
        });
    }

    editTask() {
        this.showSpinner();
        this.ApiTasks.putTask(this.task).then((res) => {
            this.hideSpinner();
            if (!res) return;
            // if (ionic.Platform.isWebView())
            // this.editCalenderEventInMobile(this.currentTaskCopy, this.task); expected in release 2.0
            this.redirectToCallingPage();
        });
    }

    validate() {
        let flag = true;
        if (this.isStartDateAfterDueDate()) {
            flag = false;
        }
        return flag;
    }

    redirectToCallingPage() {
        // let callingPage = this.$stateParams.callingPage;
        // let referenceId = this.$stateParams.referenceId;
        // if (!callingPage) {
        //     this.$state.go('tasks', {}, { reaload: true });
        // } else if (callingPage == 'campaign-detail' && referenceId) {
        //     this.$state.go('campaignDetail', { campaignId: referenceId }, { reload: true });
        // }
        // else {

        // }
        this.TaskMutationTrackingService.redirectToStateInSessionStore();
    }



    createCalenderEventInMobile(task) {
        let event = task.task || task;
        let eventDate = new Date(event.dueDate);
        let startDate = new Date(eventDate.setHours(9));
        let dueDate = new Date(eventDate.setHours(10));
        event.taskDescription = event.taskDescription || '';
        event.comment = event.comment || '';
        this.$cordovaCalendar.createEvent({
            title: this.task.task.taskSubject,
            location: task.taskId,
            notes: 'Description: ' + event.taskDescription + '\nComment: ' + event.comment,
            startDate: startDate,
            endDate: dueDate
        });
    }

    editCalenderEventInMobile(oldTask, newTask) {
        this.deleteCalenderEventFromMobile(oldTask)
            .then((result) => {
                this.createCalenderEventInMobile(newTask);
            }, (error) => {
                this.createCalenderEventInMobile(newTask);
                this.errorMsg = error;
            });
    }

    deleteCalenderEventFromMobile(task) {
        let event = task.task || task;
        let eventDate = new Date(event.dueDate);
        let startDate = new Date(event.dueDate);
        let dueDate = new Date(event.dueDate);
        startDate.setFullYear(startDate.getFullYear() - 3);
        dueDate.setFullYear(dueDate.getFullYear() + 3);
        event.taskDescription = event.taskDescription || '';
        event.comment = event.comment || '';
        return this.$cordovaCalendar.deleteEvent({
            title: null,
            location: event.taskId,
            notes: null,
            startDate: new Date(startDate),
            endDate: new Date(dueDate)
        })
    }

    isStartDateAfterDueDate() {
        if (this.task && this.task.task) {
            let startDate = this.removeTimeFromDateAndAddHour(this.task.task.startDate, 0);
            let dueDate = this.removeTimeFromDateAndAddHour(this.task.task.dueDate, 1);
            // console.log('> startDate ', Date.parse(startDate));
            // console.log('> dueDate ', Date.parse(dueDate));
            let flag = Date.parse(startDate) > Date.parse(dueDate);
            return flag;
        }
    }

    removeTimeFromDate(dateString) {
        return new Date(new Date(dateString).setHours(0, 0, 0));
    }

    removeTimeFromDateAndAddHour(dateString, hour) {
        return new Date(new Date(dateString).setHours(hour, 0, 0));
    }

    resolveRedirection() {
        let self = this;
        let isCampaignTaskRedirection = this.$stateParams.campaignId;
        let isCampaignContactRedirection = this.$stateParams.campaignId && this.$stateParams.contactId;
        let isContactTaskRedirection = this.$stateParams.contactId && !isCampaignTaskRedirection && !isCampaignContactRedirection;

        if (isCampaignTaskRedirection || isCampaignContactRedirection) {
            self.task.task.relatedTo = 'CAMPAIGN';
            self.loadCampaigns().then(() => {
                let campaignId = self.$stateParams.campaignId;
                self.assignRelatedCampaign(campaignId);
                self.loadCampaignContacts(campaignId).then(() => {
                    self.assignRelatedCampaignContact(self.$stateParams.contactId);
                });
            });
        } else if (isContactTaskRedirection) {
            self.task.task.relatedTo = 'CONTACT';
            self.loadContact(this.$stateParams.contactId, this.$stateParams.isCustomerContact);
        }

        let investorId = self.$stateParams.investorId || self.$stateParams.customerInvestorId;
        if (investorId) {
            let isCustomInvestor = self.$stateParams.customerInvestorId != null;
            self.task.task.relatedTo = 'INVESTOR';
            self.loadAccount(investorId, isCustomInvestor);
        }
    }

    assignRelatedCampaign(campaignId) {
        let self = this;
        let campaign = self.campaigns.filter((c) => {
            return c.campaignId == campaignId;
        });
        self.task.campaign = campaign[0];
    }

    assignRelatedCampaignContact(contactId) {
        let self = this;
        self.task.contactExtension = self.contacts.filter((contactExtension) => {
            return contactExtension.contactInfo.contact.id == contactId;
        })[0];
    }

    getCampaignContacts(campaignId) {
        this.task.contactExtension = undefined;
        this.loadCampaignContacts(campaignId);
        this.showModal();
    }

    checkContactAccess() {
        var assigneeId = null;
        var contactId = null;
        var isCustomerContact = null;
        var campaignId = null;

        if (this.task.assignee) {
            assigneeId = this.task.assignee.id;
        }

        if (this.task.contactExtension && this.task.contactExtension.contactInfo && this.task.contactExtension.contactInfo.contact) {
            contactId = this.task.contactExtension.contactInfo.contact.id;
            isCustomerContact = !!this.task.contactExtension.contactInfo.contact.customer;
        }

        if (this.task.campaign) {
            campaignId = this.task.campaign.campaignId;
        }

        if (assigneeId && contactId) {
            this.ApiContacts.checkContactAccess(assigneeId, contactId, isCustomerContact, campaignId).then((res) => {
                if (!res && res !== undefined) {
                    this.$ionicPopup.alert({
                        title: '<b>' + this.$filter('translate')('LICENSE_REQUIRED_POPUP_TITLE') + '</b>',
                        template: this.$filter('translate')('LICENSE_REQUIRED_POPUP_CONTENT'),
                        okType: 'button-picton-blue'
                    });
                }
            });
        }
    }


    checkAccountAccess() {
        var assigneeId = null;
        var investorId = null;
        var isCustomerInvestor = null;

        if (this.task.assignee) {
            assigneeId = this.task.assignee.id;
        }
        if (this.task.investor && this.task.investor.investor) {
            investorId = this.task.investor.investor.investorId;
            isCustomerInvestor = !!this.task.investor.investor.customer;
        } else if (this.task.investor) {
            investorId = this.task.investor.investorId;
            isCustomerInvestor = !!this.task.investor.customer;
        }

        if (assigneeId && investorId) {
            this.ApiInvestors.checkAccountAccess(assigneeId, investorId, isCustomerInvestor).then((res) => {
                if (!res && res !== undefined) {
                    this.$ionicPopup.alert({
                        title: '<b>' + this.$filter('translate')('LICENSE_REQUIRED_POPUP_TITLE_ACCOUNT') + '</b>',
                        template: this.$filter('translate')('LICENSE_REQUIRED_POPUP_CONTENT_ACCOUNT'),
                        okType: 'button-picton-blue'
                    });
                }
            });
        }
    }

    onDateChange(date) {
        if (date === 'startDate') {
            this.startDate_required = false;
        } else if (date === 'dueDate') {
            this.dueDate_required = false;
        }
    }

    checkDateFormats() {
        let dateInvalid = false;
        if (this.task.task.startDate === this.DATE_FORMAT) {
            dateInvalid = true;
            this.startDate_required = true;
        } else {
            this.startDate_required = false;
        }

        if (this.task.task.dueDate === this.DATE_FORMAT) {
            dateInvalid = true;
            this.dueDate_required = true;
        } else {
            this.dueDate_required = false;
        }

        return dateInvalid;
    }

    changeRelatedTo() {
        this.task.investor = null;
        this.task.campaign = null;
        this.task.contactExtension = null;
        if (this.task.task.relatedTo === 'CAMPAIGN') {
            this.openCampaignSearchModal();
        }
    }

    loadCampaigns() {
        return this.ApiCampaigns.getCampaignsMinimal().then((res) => {
            if (typeof res != 'undefined') {
                this.campaigns = res;
            }
        });
    }

    loadCampaignContacts(campaignId) {
        return this.ApiCampaigns.getCampaignContacts(campaignId).then((res) => {
            this.contacts = res || [];
        });
    }

    resetContactList() {
        this.contacts = [];
        this.contactsMoreData = false;
    }

    showModal() {

        this.contactExtension = angular.copy(this.task.contactExtension);
        this.filter = { 'investorSubtypes': angular.copy(this.investorSubtypes) };

        if (this.task.task.relatedTo === 'CONTACT') {
            this.search = '';
            this.contactSearchText = '';
            this.resetContactList();
            this.filter = { 'investorSubtypes': angular.copy(this.investorSubtypes) };
            if (this.task.contactExtension) {
                let id = '';
                if (this.task.contactExtension.contactInfo.contact.customer) {
                    id = 'TEAM';
                } else {
                    id = 'PACKAGE';
                }
                this.filter.contactType = this.contactTypes.filter((contact) => {
                    return contact.id === id;
                })[0];
                this.onContactChange();
            }
            this.addContactModal.show();
            this.onContactsClick(0);
        } else if (this.task.task.relatedTo === 'INVESTOR') {
            this.addAccountModal.show();
            this.onInvestorContactsClick(0);
        } else {
            this.addContactModal.show();
        }
    }

    cancelModal() {
        this.searchPerformed = false;
        this.task.contactExtension = this.contactExtension;
        if (this.task.task.relatedTo === 'INVESTOR') {
            this.addAccountModal.hide();
        } else {
            this.addContactModal.hide();
        }
    }

    closeModal() {
        this.searchPerformed = false;
        if (this.task.task.relatedTo === 'INVESTOR') {
            this.addAccountModal.hide();
        } else {
            this.addContactModal.hide();
        }
    }

    closeAllModelsUnconditionally() {
        this.addAccountModal.hide();
        this.addContactModal.hide();
    }

    showChildren(id, parent) {
        if (id) {
            switch (parent) {
                case 'packageOne':
                    this.ApiSelections.getSelectionChildren(id).then((packagesTwo) => {
                        this.packageTwo = packagesTwo || [];
                    });
                    break;
                case 'packageTwo':
                    this.ApiSelections.getSelectionChildren(id).then((packagesThree) => {
                        this.packageThree = packagesThree || [];
                    });
                    break;
                case 'packageThree':
                    this.ApiSelections.getSelectionChildren(id).then((packagesFour) => {
                        this.packageFour = packagesFour || [];
                    });
                    break;
                default:
                    return false;
            }
        }
    }

    onContactChange() {
        this.task.contactExtension = undefined;
        this.contacts = [];
        if (this.filter.contactType.id === 'PACKAGE') {
            this.ApiSelections.getSelectionsMinimal().then((packages) => {
                this.packageOne = packages || [];
            });
        }
    }

    searchContacts(text) {
        this.searchPerformed = true;
        this.filterParameterObj = {
            investorSubtypes: [],
            selectionId: undefined,
            searchText: this.searchContactText,
            firstQueryResult: undefined,
            sortOrder: 'AUM',
            sortDirection: 'DESC'
        };

        this.filter.investorSubtypes.forEach((subtype) => {
            this.filterParameterObj.investorSubtypes.push(subtype.value);
        });

        if (this.filter.contactType.id === 'PACKAGE') {
            if (this.filter.packageFour) {
                this.filterParameterObj.selectionId = this.filter.packageFour.selectionId;
            } else if (this.filter.packageThree) {
                this.filterParameterObj.selectionId = this.filter.packageThree.selectionId;
            } else if (this.filter.packageTwo) {
                this.filterParameterObj.selectionId = this.filter.packageTwo.selectionId;
            } else if (this.filter.packageOne) {
                this.filterParameterObj.selectionId = this.filter.packageOne.selectionId;
            }
            this.loadPackageContacts();
        } else {
            this.loadCustomContacts();
        }
    }

    clearSearchContacts() {
        this.searchContactText = '';
        this.searchContacts();
    }

    searchAccounts() {
        this.searchPerformed = true;
        this.filterParameterObj = {
            investorType: undefined,
            subtypes: [],
            selectionId: undefined,
            fromAum: undefined,
            toAum: undefined,
            searchText: this.searchAccountText,
            firstQueryResult: undefined,
            sortOrder: 'AUM',
            sortDirection: 'ASC'
        };

        this.filter.investorSubtypes.forEach((subtype) => {
            this.filterParameterObj.subtypes.push(subtype.value);
        });

        if (this.filter.accountType.id === 'PACKAGE') {
            this.loadPackageAccounts();
        } else {
            this.loadCustomAccounts();
        }
    }

    clearSearchAccounts() {
        this.searchAccountText = '';
        this.searchAccounts();
    }

    loadPackageContacts(filter) {
        this.loadingData = true;
        this.ApiContacts.getPackageContacts(this.filterParameterObj).then((contacts) => {
            if (contacts.length < 50) {
                this.contactsMoreData = false;
            } else {
                this.contactsMoreData = true;
            }
            this.contacts = contacts || [];
            this.loadingData = false;
        });
    }

    loadPackageAccounts(filter) {
        this.loadingData = true;
        this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then((investors) => {
            if (investors.length < 50) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = true;
            }

            this.investors = investors || [];
            this.loadingData = false;
        });
    }

    loadCustomContacts(filter) {
        this.loadingData = true;
        this.ApiContacts.getTeamContacts(this.filterParameterObj).then((contacts) => {

            if (contacts.length < 50) {
                this.contactsMoreData = false;
            } else {
                this.contactsMoreData = true;
            }
            this.contacts = contacts || [];
            this.loadingData = false;
        });
    }

    loadCustomAccounts(filter) {
        this.loadingData = true;
        this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then((investors) => {
            if (investors.length < 50) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = true;
            }

            this.investors = investors || [];
            this.loadingData = false;
        });
    }

    getMoreContacts() {
        this.filterParameterObj.firstQueryResult = this.contacts && this.contacts.length;
        if (this.filter.contactType.id === 'PACKAGE') {
            this.getMorePackageContacts();
        } else if (this.filter.contactType.id === 'TEAM') {
            this.getMoreCustomcontacts();
        }
    }

    getMoreAccounts() {
        this.filterParameterObj.firstQueryResult = this.investors && this.investors.length;
        if (this.filter.accountType.id === 'PACKAGE') {
            this.getMorePackageAccounts();
        } else if (this.filter.accountType.id === 'TEAM') {
            this.getMoreCustomAccounts();
        }
    }

    getMorePackageContacts() {
        this.loadingContacts = true;
        this.ApiContacts.getPackageContacts(this.filterParameterObj).then((contacts) => {
            if (!contacts) {
                this.contactsMoreData = false;
            } else {
                this.contactsMoreData = contacts.length < 50 ? false : true;
                this.contacts = this.contacts.concat(contacts);
                this.$scope.$broadcast('scroll.infiniteScrollComplete');
            }
            this.loadingContacts = false;
        });
    }

    getMorePackageAccounts() {
        this.loadingData = true;
        this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then((investors) => {

            if (!investors) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = investors.length < 50 ? false : true;
                this.investors = this.investors.concat(investors);
                this.$scope.$broadcast('scroll.infiniteScrollComplete');
            }
            this.loadingData = false;
        });
    }

    getMoreCustomcontacts() {
        this.loadingData = true;
        this.ApiContacts.getTeamContacts(this.filterParameterObj).then((contacts) => {
            if (!contacts) {
                this.contactsMoreData = false;
            } else {
                this.contactsMoreData = contacts.length < 50 ? false : true;
                this.contacts = this.contacts.concat(contacts);
                this.$scope.$broadcast('scroll.infiniteScrollComplete');
            }
            this.loadingData = false;
        });
    }

    getMoreCustomAccounts() {
        this.loadingData = true;
        this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then((investors) => {
            if (!investors) {
                this.investorsMoreData = false;
            } else {
                this.investorsMoreData = investors.length < 50 ? false : true;
                this.investors = this.investors.concat(investors);
                $scope.$broadcast('scroll.infiniteScrollComplete');
            }
            this.loadingData = false;
        });
    }

    loadContact(contactId, isCustomerContact) {
        this.ApiContacts.getContact(contactId, { 'isCustomerContact': isCustomerContact }).then((res) => {
            if (res) {
                this.task.contactExtension = res;
            }
        })
    }

    loadAccount(accountId, isCustomerAccount) {
        this.ApiInvestors.getInvestor(accountId, { isCustomerAccount }).then((res) => {
            if (res) {
                let customerInfo = null;
                if (isCustomerAccount) {
                    customerInfo = {
                        id: res.investor.customer && res.investor.customer.id
                    };
                }
                this.task.investor = {
                    investorId: res.investor.investorId,
                    investorName: res.investor.investorName,
                    customer: customerInfo
                }
            }
        })
    }

    formatInvestorObject() {
        this.task.investor = {
            investorId: this.task.investor.investor.investorId,
            investorName: this.task.investor.investor.investorName,
            customer: this.task.investor.investor.customer
        }
    }

    //
    // Campaign Search Modal
    //
    openCampaignSearchModal() {
        this.resetFilter();
        this.campaignLoading = true;
        this.loadCampaigns().then(() => {
            this.campaignLoading = false;
        })
        this.campaignSearchModal.show();
    };

    closeCampaignSearchModal() {

        this.campaignSearchModal.hide();
    }

    searchCampaigns(searchText) {
        this.search = searchText;
    };

    clearSearchCampaigns() {
        this.search = '';
    }

    searchCampaignContact(text) {
        this.searchCampaignContactFilter = text;
    }

    clearSearchCampaignContact() {
        this.searchCampaignContactText = '';
        this.searchCampaignContactFilter = undefined;
    }


    assignCampaign(campaign) {
        this.task.campaign = campaign;
        this.getCampaignContacts(this.task.campaign.campaignId);
        this.closeCampaignSearchModal();
    };

    resetFilter() {
        this.filter = {};
        this.search = '';
        this.campaignSearchText = '';
        this.contactSearchText = '';
        this.selectedCampaign = null;
    }

    onContactsClick(buttonNumber) {
        this.contactTypes.map(c => c.selected = false);
        this.contactTypes[buttonNumber].selected = true;
        this.filter.contactType = this.contactTypes[buttonNumber];
        this.searchContacts();
    }

    onInvestorContactsClick(buttonNumber) {
        this.accountTypes.map(c => c.selected = false);
        this.accountTypes[buttonNumber].selected = true;
        this.filter.accountType = this.accountTypes[buttonNumber];
        this.searchAccounts();
    }

    updateFocusForComments(focus) {
        this.commentInFocus = focus;
    }

    updateFocusForSummary(focus) {
        this.summaryInFocus = focus;
    }

}



/** WEBPACK FOOTER **
 ** ./src/app/components/tasks/taskAdd.controller.js
 **/